<template>
    <v-container class="slides custom-gray d-flex align-stretch pa-0 my-10" fluid>
        <v-row :id="name" class="custom-gray ma-0" justify="center">
            <v-col 
                :cols="!!$mq.phone ? 12 : 5" 
                class="pa-10"
                :class="`${ imgPosition === 'right' ? 'order-last' : 'order-first' }`"
            >
                <v-card
                    tile
                    elevation="10"
                    width="100%"
                    :height="!!$mq.phone ? '40vh' : '100%'"
                    :class="!!$mq.phone ? 'ma-5' : 'ma-0'"
                    class="mx-auto"
                >
                    <v-carousel
                        cycle
                        show-arrows
                        hide-delimiters
                        delimiter-icon="mdi-minus"
                        height="100%"
                    >
                        <v-carousel-item
                            v-for="(slide, i) in content.slides"
                            :key="`${ name }-slide-${ i }`"
                            height="100%"
                            @mouseover="hover = true"
                            @mouseleave="hover = false"
                        >
                            <div 
                                class="slide-image d-flex fill-height align-end" 
                                :style="{ backgroundImage: `url(${ slide.src })` }"
                                @click="run( 'openViewer', slide )"
                            >
                                <div 
                                    class="d-flex flex-column custom-gray flex-fill px-5 py-3"
                                    :class="hover ? 'custom-gray' : 'semi-gray'"
                                >
                                    <span class="custom-white-text">{{ slide.desc }}</span>
                                    <small v-if="!!slide.dimensions" class="custom-white-text">{{ slide.dimensions }}</small>
                                    <small v-if="!!slide.location" class="custom-white-text">{{ slide.location }}</small>
                                </div>
                            </div>
                        </v-carousel-item>
                    </v-carousel>
                </v-card>
            </v-col>
            
            <v-col 
                :cols="!!$mq.phone ? 12 : !!$mq.tablet ? 7 : 5" 
                class="d-flex align-center px-10"
            >
                <v-card
                    flat
                    color="transparent"
                    class="content-card"
                    :class="`${ imgPosition === 'left' || !!$mq.phone ? 'text-left' : 'text-right' }`"
                >
                    <v-card-title 
                        class="d-flex"
                        :class="`${ !!$mq.phone ? ' justify-center' : imgPosition === 'right' ? 'justify-end' : 'justify-start' }`"
                    >
                        <h2 class="custom-white-text" :class="$mq.phone ? '' : !!$mq.tablet ? 'display-1' : 'display-2'">{{ content.title }}</h2>
                    </v-card-title>

                    <v-card-text>
                        <p v-for="(pragraph, i) in content.text" :key="`${ name }-paragraph-${ i }`" class="custom-white-text">
                            {{ pragraph }}
                        </p>
                    </v-card-text>

                    <v-card-actions 
                        v-if="!!content.action"
                        :class="`${ imgPosition === 'right' ? 'justify-end' : 'justify-start' }${ !!$mq.phone ? ' justify-center' : '' }`"
                    >
                        <CTABtn :item="content.action" class="mt-5" light />
                        <!-- <router-link
                            class="action-link"
                            dark 
                            :to="content.action.to"
                        >
                            <v-icon v-if="content.action.prependIcon" left>mdi-{{ content.action.prependIcon }}</v-icon>
                            {{ content.action.title }}
                        </router-link> -->
                    </v-card-actions>
                </v-card>        
            </v-col>

        </v-row>
    </v-container>
</template>

<script>
import CTABtn from '@/components/CTABtn'

export default {
    name: 'Slides',
    components: {
        CTABtn
    },
    props: [
        'name',
        'imgPosition',
    ],
    data() {
        return {
            hover: false,
            cycle: null,
            model: null,
        }
    },
    computed: {
        content() {
            switch( this.name ) {
                case 'urban-furniture':
                    return {
                        title: 'Mobilier Urbain',
                        text: [
                            `Nous créons des meubles ainsi que des objets stylisés et uniques.`,
                                
                            `Dû au procédé de réalisation, les objets peuvent avoir la même forme, mais restent uniques 
                            puisque les mélanges sont mis manuellement dans le moule puis compactés.`,
                            
                            `Selon la demande, des designs sur mesure peuvent être réalisés.`,
                        ],
                        action: {
                            prependIcon: `forum-outline`,
                            title: `Parlez-nous de votre projet`,
                            to: {
                                path: '/',
                                hash: '#contact'         
                            },
                        },
                        slides: [
                            {
                                src: require(`@/assets/img/furniture-slides/slide-1.jpg`),
                                w: 2500,
                                h: 1200,
                                thumbnail: require(`@/assets/img/furniture-slides/thumbnail-1.jpg`),
                                alt: `Bac (17,75" x 17,75" x 28,75")`,
                                desc: `Bac`,
                                dimensions: `17,75" x 17,75" x 28,75"`,
                                location: null,
                            },
                            {
                                src: require(`@/assets/img/furniture-slides/slide-2.jpg`),
                                w: 2500,
                                h: 1200,
                                thumbnail: require(`@/assets/img/furniture-slides/thumbnail-2.jpg`),
                                alt: `Bac (28" x 28" x 24")`,
                                desc: `Bac`,
                                dimensions: `28" x 28" x 24"`,
                                location: null,
                            },
                            {
                                src: require(`@/assets/img/furniture-slides/slide-3.jpg`),
                                w: 2500,
                                h: 1200,
                                thumbnail: require(`@/assets/img/furniture-slides/thumbnail-3.jpg`),
                                alt: `Banc de parc (72")`,
                                desc: `Banc de parc`,
                                dimensions: `72"`,
                                location: null,
                            },
                        ],
                    }
                    
                default:
                    return
            }
        },
    },
    methods: { 
        run(method, params = null) {
            if(typeof this[method] === 'function') {
                !!params ? this[method](params) : this[method]()
            }
            else {
                this.$emit('run', method, params)
            }
        },
    },
  }
</script>

<style scoped>
.slides {
    min-height: 50vh;
}

.slide-image {
    background-size: contain;
    background-position: center;
}

.slide-image > * {
    transition: all .5s;
    cursor: pointer;
}

.content-card {
    width: 100%;
}

.v-card__title > * {
    word-break: normal;
}

/* .action-link,
.action-link > * {
    color: #30B700;
    text-decoration: none;
}

.action-link {
    border: 2px solid #30B700;
    border-radius: 4px;
    padding: 4px 20px;
} */
</style>
